<template>
	<v-card color="contained">
		<v-card-text>
			<img src="https://assets.livereader.com/asset/AM6W1mRRtqe3AyUE.png" style="height: 256px; width: auto" />
			<p style="text-align: center; font-size: large; font-weight: bold">02408 - 9382529</p>
		</v-card-text>
	</v-card>
</template>
